import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { FormikProps } from 'formik';

interface Props {
	className?: string;
	name?: string;
	formikBag?: FormikProps<any>;
	onChange?: (val: string) => void;
	onExpired?: () => void;
}

const sitekey = '6LezTMIcAAAAACaXvLNse5bmTJpwqs0Ezm_bhTrU';

const CustomReCAPTCHA: React.FC<Props> = ({
	className = '',
	name = 'captcha',
	formikBag,
	onChange,
	onExpired,
}) => {
	const handleChange = (val: string) => {
		if (onChange) {
			onChange(val);
			return;
		}

		if (!formikBag) return;
		formikBag.setFieldValue(name, val || '');
	};

	const handleExpired = () => {
		if (onExpired) {
			onExpired();
			return;
		}

		if (!formikBag) return;
		formikBag.setFieldValue(name, 'expired');
	};

	return (
		<ReCAPTCHA
			sitekey={sitekey}
			className={className}
			onChange={handleChange}
			onExpired={handleExpired}
			hl="en"
		/>
	);
};

export default CustomReCAPTCHA;
